import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AddskillspopupComponent } from '../generalpopup/addskillspopup/addskillspopup.component';

@Component({
  selector: 'app-empskills',
  templateUrl: './empskills.component.html',
  styleUrls: ['./empskills.component.css']
})
export class EmpskillsComponent implements OnInit {



  constructor(private toastr: ToastrService,private appService: AppdataService,
    public loginService:LoginserviceService,private activeModal: NgbActiveModal,private confirmationDialogService: ConfirmationDialogService,
    private productFindService: NgbModal,) { }

//Save Validation
submitted:boolean;
successfully:boolean;

empskillsform=new FormGroup({
skillsid:new FormControl(0,Validators.required),          
institution:new FormControl('',Validators.required),   
completeon:new FormControl(''),   
descr:new FormControl(''),   
});

//Edit Get Values
skillsColl:any=[];

@Input() empskillsid:any=0;
@Input() skillsid:any=null
@Input() institution:any=null;
@Input() completeon:any=null;
@Input() descr:any=null;

@Output() emitData = new EventEmitter();


ngOnInit() {

this.empskillsform.reset();
this.fnInitializeFormGroup(); 
this.fngetSkills();
}


fnInitializeFormGroup(){
this.empskillsform.setValue({
  skillsid:this.skillsid,    
  institution:this.institution,   
  completeon:this.completeon,     
  descr:this.descr,    
})
}

//Get 
fngetSkills() {
  var data = {
  'skillsid':0,
  'companyid':this.loginService.fnGetCompanyId()          
  }
  this.appService.getSkills(data)
  .subscribe(
  (res)=>{                
  if(res.json().status===200){  
  this.skillsColl=res.json().result;     
  }
  else {
  this.loginService.fnAPIError(res.json())
  }

  },
  (err)=>{          
  this.toastr.error('Error', err);
  })
}

fnSaveBtnClick(){
try{
this.submitted=true;
this.successfully=false;
//Validate
if(this.empskillsform.valid){

const index = this.skillsColl.findIndex(sku => sku.skillsid === this.empskillsform.get('skillsid').value); 

//Check
var data = {
  empskillsid: this.empskillsid,                      
  skillsid:this.empskillsform.get('skillsid').value, 
  skillsname:this.skillsColl[index].skillsname, 
  institution:this.empskillsform.get('institution').value,     
  completeon:this.empskillsform.get('completeon').value,   
  descr:this.empskillsform.get('descr').value,                     
}
this.emitData.emit(data);  
this.activeModal.close(true);  

}

}catch(ex){
this.fnShowErrorMsg(ex);
}
}
//AddDeduction
private fnAddSkills() {

  const modalRef = this.productFindService.open(AddskillspopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetSkills();

    if (receivedEntry > 0) {
      this.empskillsform.patchValue({ skillsid: receivedEntry })
    }
  });

}


public decline() {
this.activeModal.close(false);
}


private  fnShowErrorMsg(ex){
  console.log(ex)
this.toastr.warning('Internal Error', ex);       
}





}
